import {useQuery} from "@tanstack/react-query";
import {ISailMaterial} from "../declarations";
import {createApiClient} from "../utilities/apiClient";

const getSailInfoSailMaterial=async (guid: string): Promise<ISailMaterial> => {
    const axiosSailTag=createApiClient();
    const response=await axiosSailTag.get<ISailMaterial>(`/api/SailInfo/GetSailInfoSailMaterial/${encodeURIComponent(guid)}`);
    return response.data;
};

export const useGetSailInfoSailMaterial=(guid: string) =>
    useQuery<ISailMaterial>({
        queryKey: [
            "GetSailInfoSailMaterial  ",
            {
                guid: guid??null
            }
        ],
        queryFn: () => {
            if(!guid?.trim()) {
                throw new Error("Invalid params for GetSailInfoSailMaterial");
            }
            return getSailInfoSailMaterial(guid);
        },
        enabled: Boolean(guid?.trim()),
        refetchOnWindowFocus: true,
        retry: false
    });